import React, { useEffect, useState } from 'react';
import { Modal, ResponsiveImage } from '../../../../components';
import ProfileIconCard from '../../../../components/ProfileIconCard/ProfileIconCard';
import {
  abbreviateName,
  createPostBodyHelper,
  getInitialValuesForEditPost,
  transformRawContent,
} from '../../../../util/circleHelper';
import css from './CreatePostBar.module.css';
import CreatePostForm from '../CreatePostForm/CreatePostForm';
import { manageDisableScrolling } from '../../../../ducks/ui.duck';
import {
  clearSpaceTopics,
  getSpaceTopics,
  toggelCoverImageReducer,
  toggelDocumentReducer,
  toggelGiphyReducer,
  toggelImageReducer,
  toggelVideoReducer,
  toggleEditPost,
} from '../../CircleCommunityPage.duck';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { CompositeDecorator, EditorState, Modifier, convertToRaw } from 'draft-js';

const mentionStrategy = (contentBlock, callback, contentState) => {
  const text = contentBlock.getText();
  let matchArr, start;
  const regex = /@\w+/g; // Detect mentions starting with '@'
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
};

const Mention = props => (
  <span style={{ backgroundColor: '#e8f5ff', color: '#0073e6' }}>{props.children}</span>
);

const compositeDecorator = new CompositeDecorator([
  {
    strategy: mentionStrategy,
    component: Mention,
  },
]);

const CreatePostBar = props => {
  const {
    currentCommunityMember,
    spaceListData,
    onCreateSpacePost,
    requestDirectUpload,
    isCreatePost = false,
    onToggleCreatePost,
    onGiphyChange,
    onDocumentClick,
    onImageClick,
    onVideoClick,
    isGiphyOpen,
    isDocumentModal,
    isImageModal,
    isVideoUpload,
    editPostData,
    onFetchTopics,
    spaceTopicsData,
    advancedSearchData,
    onAdvancedSearch,
    params,
    onClearSpaceTopics,
    isCoverImageModal,
    onManageDisableScrolling,
    onCoverImageClick,
  } = props;

  const postId = editPostData?.id || null;
  const dispatch = useDispatch();
  const [editorState, setEditorState] = useState(EditorState.createEmpty(compositeDecorator));
  // const [formateEditor, setFormateEditor] = useState(false);
  const [formOldValues, setFormOldValues] = useState(() =>
    getInitialValuesForEditPost(editPostData)
  );
  useEffect(() => {
    setFormOldValues(() => getInitialValuesForEditPost(editPostData));
  }, [editPostData]);

  const { avatar_url } = currentCommunityMember || {};

  const [searchTerm, setSearchTerm] = useState('');
  const [isEmoji, setIsEmoji] = useState(false);

  const handlePostCreation = async values => {
    const contentState = editorState?.getCurrentContent();
    const rawContent = convertToRaw(contentState); // Convert to raw JS object
    const formateEditor = transformRawContent(rawContent);
    const apiParams = createPostBodyHelper(values, formateEditor);
    onCreateSpacePost(apiParams, values.spaceId);
    setEditorState(EditorState.createEmpty(compositeDecorator));
    onToggleCreatePost();
    dispatch(toggleEditPost({}));
  };

  const handleCloseModal = () => {
    onClearSpaceTopics();
    onToggleCreatePost();
    dispatch(toggleEditPost({}));
    setEditorState(EditorState.createEmpty(compositeDecorator));
  };

  const insertEmoji = emoji => {
    const currentContent = editorState.getCurrentContent();
    const selection = editorState.getSelection();

    // Make sure the insertion is at the cursor's current position
    if (!selection.isCollapsed()) {
      const newContentState = Modifier.replaceText(currentContent, selection, emoji);
      const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');
      setEditorState(newEditorState);
    } else {
      // If the selection is collapsed (no text selected), append the emoji
      const newContentState = Modifier.insertText(currentContent, selection, emoji);
      const newEditorState = EditorState.push(editorState, newContentState, 'insert-characters');
      setEditorState(newEditorState);
    }
    setIsEmoji(false);
  };

  return (
    <>
      <div className={css.createPostWrapper} onClick={onToggleCreatePost}>
        <div className={css.imageleft}>
          <div className={css.imageContainer}>
            {avatar_url ? (
              <ResponsiveImage imagewithURL={avatar_url} />
            ) : currentCommunityMember?.name ? (
              <div className={css.nameWrapper}>{abbreviateName(currentCommunityMember?.name)}</div>
            ) : null}
          </div>
          <span className={css.startHeading}>Start a post</span>
        </div>
        <ProfileIconCard type="add" />
      </div>
      {/* create a modal here which will open onclick of create a post button*/}
      {isCreatePost ? (
        <Modal
          className={css.createPostModal}
          id={'createPostModal'}
          isOpen={isCreatePost}
          onClose={handleCloseModal}
          onManageDisableScrolling={onManageDisableScrolling}
        >
          <CreatePostForm
            editorState={editorState}
            setEditorState={setEditorState}
            insertEmoji={insertEmoji}
            initialValues={formOldValues}
            formOldValues={formOldValues}
            setFormOldValues={setFormOldValues}
            onSubmit={handlePostCreation}
            spaceListData={spaceListData}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            isEmoji={isEmoji}
            setIsEmoji={setIsEmoji}
            requestDirectUpload={requestDirectUpload}
            onGiphyChange={onGiphyChange}
            onDocumentClick={onDocumentClick}
            onImageClick={onImageClick}
            onVideoClick={onVideoClick}
            isGiphyOpen={isGiphyOpen}
            isDocumentModal={isDocumentModal}
            isImageModal={isImageModal}
            isVideoUpload={isVideoUpload}
            onFetchTopics={onFetchTopics}
            spaceTopicsData={spaceTopicsData}
            advancedSearchData={advancedSearchData}
            onAdvancedSearch={onAdvancedSearch}
            params={params}
            isCoverImageModal={isCoverImageModal}
            onCoverImageClick={onCoverImageClick}
          />
        </Modal>
      ) : null}
    </>
  );
};

const mapStateToProps = state => {
  const {
    isGiphyOpen,
    isDocumentModal,
    isImageModal,
    isVideoUpload,
    editPostData,
    requestSpaceTopics,
    spaceTopicsData,
    isCoverImageModal,
  } = state.CircleCommunityPage;

  return {
    isGiphyOpen,
    isDocumentModal,
    isImageModal,
    isVideoUpload,
    editPostData,
    requestSpaceTopics,
    spaceTopicsData,
    isCoverImageModal,
  };
};
const mapDispatchToProps = dispatch => ({
  onGiphyChange: () => dispatch(toggelGiphyReducer()),
  onDocumentClick: () => dispatch(toggelDocumentReducer()),
  onCoverImageClick: () => dispatch(toggelCoverImageReducer()),
  onImageClick: () => dispatch(toggelImageReducer()),
  onVideoClick: () => dispatch(toggelVideoReducer()),
  onFetchTopics: spaceId => dispatch(getSpaceTopics(spaceId)),
  onClearSpaceTopics: () => dispatch(clearSpaceTopics()),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});
export default compose(connect(mapStateToProps, mapDispatchToProps))(CreatePostBar);
